import { FEATURES } from "../config/features";

const STORAGE_KEY = "sp.webReminders.v1";

export function rememberWebReminders(payload) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    // The signup still stands if the browser blocks storage.
  }
}

export function sendWebReminder(kind) {
  // Level 1: the simulator never fires a real SMS. The SMS outbox (lot 4) replaces this.
  if (!FEATURES.legacyWebSms) return Promise.resolve();
  let saved = null;
  try {
    saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "null");
  } catch {
    saved = null;
  }
  if (!saved?.smsReminders || !saved.reminderToken) return Promise.resolve();
  const base = process.env.REACT_APP_BACKEND_URL || "";
  return fetch(`${base}/api/reminders/web`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ reminderToken: saved.reminderToken, kind }),
  }).catch(() => null);
}
